import React, {useState} from 'react';
import {Button, Menu, MenuItem, useMediaQuery, useTheme} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import 'flag-icons/css/flag-icons.min.css';
import AppLanguage from "./AppLanguage";
import LanguageHandler from "./LanguageHandler";

const languageMap = {
    [AppLanguage.RO]: {name: 'Română', flag: 'fi-ro'},
    [AppLanguage.EN]: {name: 'English', flag: 'fi-gb'},
    [AppLanguage.IT]: {name: 'Italiano', flag: 'fi-it'},
    [AppLanguage.DE]: {name: 'Deutsch', flag: 'fi-de'},
    [AppLanguage.FR]: {name: 'Français', flag: 'fi-fr'},
    [AppLanguage.ES]: {name: 'Español', flag: 'fi-es'},
    [AppLanguage.HU]: {name: 'Magyar', flag: 'fi-hu'}
};

const LanguageDropdown = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLanguageChange = (language: AppLanguage) => {
        LanguageHandler.setLanguage(language);
        handleClose();
    };

    return (
        <>
            <Button
                onClick={handleClick}
                endIcon={<KeyboardArrowDownIcon/>}
                sx={{minWidth: 'auto', textTransform: 'none'}}
            >
                <span className={`fi ${languageMap[LanguageHandler.getLanguage()].flag}`}></span>
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: isMobile ? 'right' : 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: isMobile ? 'right' : 'left',
                }}
            >
                {Object.entries(languageMap).map(([lang, {name, flag}]) => (
                    <MenuItem
                        key={lang}
                        onClick={() => handleLanguageChange(lang as AppLanguage)}
                        selected={LanguageHandler.getLanguage() === lang}
                    >
                        <span className={`fi ${flag}`} style={{marginRight: '8px'}}></span>
                        {name}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default LanguageDropdown;